
export default {

    banks(state,data){
        state.banks = data
    },

    bank(state,data){
        state.bank = data
    }
}